import React from 'react';
import { Store } from 'lucide-react';
import { getProductImageUrl, getProductName } from '../../utils/helpers';

const ConversationListItem = ({
  conversation,
  product,
  storeName,
  isSelected,
  unread,
  timeLabel,
  preview,
  onSelect,
}) => (
  <li>
    <button
      type="button"
      className={`mp-conv-item ${isSelected ? 'mp-conv-item--active' : ''}`}
      onClick={onSelect}
    >
      <div className="mp-conv-item__avatar">
        <img
          src={getProductImageUrl(product)}
          alt={getProductName(product) || storeName}
        />
        {unread > 0 && <span className="mp-conv-item__badge">{unread > 9 ? '9+' : unread}</span>}
      </div>
      <div className="mp-conv-item__body">
        <div className="mp-conv-item__top">
          <h2 className="mp-conv-item__title">{getProductName(product) || storeName}</h2>
          {timeLabel && <span className="mp-conv-item__time">{timeLabel}</span>}
        </div>
        <p className="mp-conv-item__store">
          <Store size={12} />
          {storeName}
        </p>
        <p className="mp-conv-item__preview">{preview}</p>
      </div>
    </button>
  </li>
);

export default ConversationListItem;
